var _path, _path2, _ellipse, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgCompany = function SvgCompany(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "company_svg__ionicon",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 32,
    d: "M176 416v64M80 32h192a32 32 0 0 1 32 32v412a4 4 0 0 1-4 4H48h0V64a32 32 0 0 1 32-32m240 160h112a32 32 0 0 1 32 32v256h0-160 0V208a16 16 0 0 1 16-16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M98.08 431.87a16 16 0 1 1 13.79-13.79 16 16 0 0 1-13.79 13.79m0-80a16 16 0 1 1 13.79-13.79 16 16 0 0 1-13.79 13.79m0-80a16 16 0 1 1 13.79-13.79 16 16 0 0 1-13.79 13.79m0-80a16 16 0 1 1 13.79-13.79 16 16 0 0 1-13.79 13.79m0-80a16 16 0 1 1 13.79-13.79 16 16 0 0 1-13.79 13.79m80 240a16 16 0 1 1 13.79-13.79 16 16 0 0 1-13.79 13.79m0-80a16 16 0 1 1 13.79-13.79 16 16 0 0 1-13.79 13.79m0-80a16 16 0 1 1 13.79-13.79 16 16 0 0 1-13.79 13.79m0-80a16 16 0 1 1 13.79-13.79 16 16 0 0 1-13.79 13.79m80 320a16 16 0 1 1 13.79-13.79 16 16 0 0 1-13.79 13.79m0-80a16 16 0 1 1 13.79-13.79 16 16 0 0 1-13.79 13.79m0-80a16 16 0 1 1 13.79-13.79 16 16 0 0 1-13.79 13.79"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 256,
    cy: 176,
    fill: "currentColor",
    rx: 15.95,
    ry: 16.03,
    transform: "rotate(-45 255.99 175.996)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M258.08 111.87a16 16 0 1 1 13.79-13.79 16 16 0 0 1-13.79 13.79M400 400a16 16 0 1 0 16 16 16 16 0 0 0-16-16m0-80a16 16 0 1 0 16 16 16 16 0 0 0-16-16m0-80a16 16 0 1 0 16 16 16 16 0 0 0-16-16m-64 160a16 16 0 1 0 16 16 16 16 0 0 0-16-16m0-80a16 16 0 1 0 16 16 16 16 0 0 0-16-16m0-80a16 16 0 1 0 16 16 16 16 0 0 0-16-16"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCompany);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;